import { cloneDeep } from "lodash";

/**
 * Utilities for working with the Objects.
 * @module DOMUtils
 */
const ObjectUtils = {
  /**
   * @description This method returns the deep cloned object.
   *
   * @param {*} value
   * @returns {*} value that has been deep cloned
   */
  deepClone(value) {
    return cloneDeep(value);
  },
};

export default ObjectUtils;
